<template>
  <div ref="contactBox"
       class="tw-fixed tw-z-50 tw-cursor-grab tw-bg-white tw-flex tw-rounded tw-items-center tw-px-2 tw-py-0.5"
       :class="{ 'tw-cursor-grabbing': isDragging }"
       :style="boxStyle"
       style="white-space: nowrap;"
       @mousedown.prevent="startDrag"
       @touchstart.prevent="startDrag"
       @dragstart.prevent>
    <a href="http://m.me/PhasiCharoenDotCom" @click="preventClickAfterDrag">
      <img src="/images/messenger.svg" alt="messenger" class="tw-w-6 tw-h-6 tw-my-2 tw-ml-0.5 tw-mr-2" draggable="false"/>
    </a>
    <span class="tw-text-xs md:tw-text-sm tw-font-light">ติดต่อเราที่ <a class="tw-font-bold tw-text-black" href="tel:026637895" @click="preventClickAfterDrag">02 663 7895</a></span>
  </div>
</template>

<script>
export default {
  name: 'ContactBox',
  data() {
    return {
      isDragging: false,
      hasDragged: false,
      x: null,
      y: null,
      offsetX: 0,
      offsetY: 0
    }
  },
  computed: {
    boxStyle() {
      const style = {
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        userSelect: 'none'
      }
      if (this.x !== null && this.y !== null) {
        style.left = this.x + 'px'
        style.top = this.y + 'px'
      } else {
        style.bottom = '0px'
        style.left = '6.5rem'
        style.marginLeft = '0.5rem'
        style.marginBottom = '0.55rem'
      }
      return style
    }
  },
  methods: {
    startDrag(e) {
      this.isDragging = true
      this.hasDragged = false

      const event = e.touches ? e.touches[0] : e
      const rect = this.$refs.contactBox.getBoundingClientRect()

      if (this.x === null) {
        this.x = rect.left
        this.y = rect.top
      }

      this.offsetX = event.clientX - rect.left
      this.offsetY = event.clientY - rect.top

      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('mouseleave', this.stopDrag)
      document.addEventListener('touchmove', this.onDrag)
      document.addEventListener('touchend', this.stopDrag)
      document.addEventListener('touchcancel', this.stopDrag)
    },
    onDrag(e) {
      if (!this.isDragging) return
      this.hasDragged = true

      const event = e.touches ? e.touches[0] : e
      const el = this.$refs.contactBox
      const elWidth = el.offsetWidth
      const elHeight = el.offsetHeight
      const maxX = window.innerWidth - elWidth
      const maxY = window.innerHeight - elHeight

      this.x = Math.min(Math.max(0, event.clientX - this.offsetX), maxX)
      this.y = Math.min(Math.max(0, event.clientY - this.offsetY), maxY)
    },
    stopDrag() {
      if (!this.isDragging) return
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('mouseleave', this.stopDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.stopDrag)
      document.removeEventListener('touchcancel', this.stopDrag)
    },
    preventClickAfterDrag(e) {
      if (this.hasDragged) {
        e.preventDefault()
        e.stopPropagation()
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    document.removeEventListener('touchmove', this.onDrag)
    document.removeEventListener('touchend', this.stopDrag)
  }
}
</script>
